export function performAjaxRequest(url, method, json, saveNo, callback) {
  $.post({
    url: url,
    type: method,
    contentType: 'application/json;charset=UTF-8',
    data: JSON.stringify(json),
    headers: {
      'X-CSRF-Token': getCsrfToken(),
    },
    success: function (response, textStatus, jqXHR) {
      if (jqXHR.redirected) {
        window.location.href = jqXHR.url;
      } else {
        callback(saveNo, true, response);
      }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      let errorData;
      try {
        errorData = JSON.parse(jqXHR.responseText);
      } catch (e) {
        errorData = { error: 'Unknown error occurred' };
      }
      callback(saveNo, false, errorData);
    },
  });
}

function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}